var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ACED",
    fillRule: "evenodd",
    d: "M8.32 16.64c1.52 0 2.927-.38 4.22-1.14 1.253-.72 2.24-1.707 2.96-2.96.76-1.293 1.14-2.7 1.14-4.22 0-1.52-.38-2.927-1.14-4.22-.72-1.253-1.707-2.24-2.96-2.96C11.247.38 9.84 0 8.32 0c-1.507 0-2.907.38-4.2 1.14-1.253.733-2.247 1.727-2.98 2.98C.38 5.413 0 6.813 0 8.32c0 1.507.38 2.907 1.14 4.2.72 1.253 1.707 2.247 2.96 2.98 1.293.76 2.7 1.14 4.22 1.14zm-1.68-4.58v-7.5l5 3.76-5 3.74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.915e81ce63bd63a1ae94d27ad7525299.svg";
export { ForwardRef as ReactComponent };